import styled from 'styled-components';
import { Handle as CustomHandle } from 'reactflow';
import { Typography } from '@mui/material';
import { IPrimayNodeContainer } from 'types';

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing(3, 3.25)};
  border-radius: 14px;
  background: ${({ color }: IPrimayNodeContainer) => color || '#53536D'};
  color: ${({ theme }) => theme.palette.common.white};
  max-width: 220px;

  transition: box-shadow 150ms ease-in-out;

  &:hover {
    box-shadow: 0px 0px 32px ${({ color }: IPrimayNodeContainer) => color || '#53536D'};
  }
`;

export const Label = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold} !important;
  text-transform: capitalize;
  text-align: center;
`;

export const Handle = styled(CustomHandle)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  background-color: #53536d;
  border: 2px solid ${({ theme }) => theme.palette.common.white};

  svg {
    width: 14px;
    height: 14px;
    fill: ${({ theme }) => theme.palette.common.white};
  }

  &:nth-child(1) {
    transform: translateY(-12px) translateX(-7px);
  }
  &:nth-child(2) {
    transform: translateY(-12px) translateX(7px);
  }
`;
